import { render, staticRenderFns } from "./allPosts.vue?vue&type=template&id=2f2ba205&scoped=true"
import script from "./allPosts.vue?vue&type=script&lang=js"
export * from "./allPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ba205",
  null
  
)

export default component.exports